import React, { useEffect, useRef, useState } from "react";

//Import Breadcrumb
import { Icon } from "@iconify/react/dist/iconify.js";
import { Chip, Grid, IconButton, Stack, Avatar, Box, ButtonBase } from "@mui/material";
import { connect, useDispatch } from "react-redux";
import { Card, Container } from "reactstrap";
import LoadingDialog from "../../components/Common/LoadingDialog";
import Notification from "../../components/Common/Notification";
import CustomButton from "../../components/Form/CustomButton";
import CustomTextField from "../../components/Form/CustomTextField";
import { resetProfileState, updateProfile, verify_admin, getProfileDataByTab, getBranchListing, createSalesman, deleteSalesman, inviteTeamMember, removeTeamMember, setSalesmanAsDefault, resetProfileActionState, getRegion, resetBranchActionState, updateBranch, deleteBranch, createBranch, getGeneral, removeTeamMemberInvitation, reinviteTeamMember } from "../../store/actions";
import Label from "../../components/Common/Label";
import RenderPopOverButton from "../../components/Form/RenderPopOverButton";
import Table from "../../components/Common/Table";
import AppDialog from "../../components/Common/AppDialog";
import DeleteModal from "../../components/Common/DeleteModal";
import Helpers from "../../helpers/helpers";
import CustomSelect from "../../components/Form/CustomSelect";
import CheckBox from "../../components/Form/CheckBox";
import UploadProductImagesNew from "../../components/Form/UploadProductImagesNew";
import AppAttachmentDialog from "../../components/Common/AppAttachmentDialog";


const UserProfile = ({ details, editUserProfile, error, userPermission, width, leftSideBarType, createSalesmanResponse, deleteSalesmanResponse, inviteTeamMemberResponse, removeTeamMemberResponse, setSalesmanAsDefaultResponse, stateList, loginStateId, regionList, userID, detailsCode, dealer_marketplace_url, branchDetails, dealer_branches, branchError, updateBranchArry, addBranchArry, delBranchArry,
    verifyAdmin, currentUser, countryList, reinviteTeamMemberResponse, removeInvitationResponse
}) => {
    const dispatch = useDispatch();
    const currentAccount = verifyAdmin?.user?.data?.profile?.selected_dealer_id ? verifyAdmin?.user?.data?.profile?.active_dealer_users?.find(user => user.dealer_id === verifyAdmin?.user?.data?.profile?.selected_dealer_id) : currentUser;

    // Helper function to extract error message from errors object
    const getErrorMessage = (response) => {
        if (response?.errors && typeof response.errors === 'object') {
            const firstErrorKey = Object.keys(response.errors)[0];
            if (firstErrorKey && Array.isArray(response.errors[firstErrorKey])) {
                return response.errors[firstErrorKey][0];
            }
        }
        return response?.message || "Please fill in all required fields";
    };

    useEffect(() => {
        dispatch(resetProfileState());
    }, []);

    useEffect(() => {
        if (userPermission?.length > 0) {
            userPermission?.includes("create-product") && setEditable(true);
            userPermission?.includes("create-product") && setDeletable(true);
        }
    }, [userPermission])


    const defaultValues = {
        fullName: "",
        email: "",
        phone: "",
        gender: "Choose",
        Nationality: "Choose",
        role: "Choose",
        password: "",
        status: "",
        joinedDate: "",
        openingHours: [],
        country_id: 192, // default Singapore
    }

    const dayList = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'PH'];
    const [values, setFormValues] = useState(defaultValues);
    const [loading, setIsLoading] = useState(false);
    const [selected, setSelected] = useState(currentAccount?.dealer_id ? "store_details" : "profile_info");

    const [attachmentOpen, setAttachmentOpen] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);

    const [editable, setEditable] = useState(true);
    const [deletable, setDeletable] = useState(true);

    const [type, setType] = useState("Add");

    // Store Details
    const [isEditStore, setIsEditStore] = useState(false);
    const postcodeRef = useRef(values?.postal_code || '');
    const [branches, setBranches] = useState([{ value: '' }]);
    const [removeBranchesIds, setRemoveBranchesIds] = useState([]);
    const [editedBranchesIds, setEditedBranchesIds] = useState([]);
    const [newBranchesIds, setNewBranchesIds] = useState([]);

    // Salesman section
    const [addSalesmanOpen, setAddSalesmanOpen] = useState(false);
    const [selectedSalesman, setSelectedSalesman] = useState("");
    const [defaultOpen, setDefaultOpen] = useState(false);
    const [isEditSalesman, setIsEditSalesman] = useState(false); // for mobile size

    // Team members section
    const [inviteUserOpen, setInviteUserOpen] = useState(false);
    const [reinviteOpen, setReinviteOpen] = useState(false);
    const [removeInvitationOpen, setRemoveInvitationOpen] = useState(false);
    const [removeMemberOpen, setRemoveMemberOpen] = useState(false);
    const [selectedMember, setSelectedMember] = useState(null);
    const [assignManagerOpen, setAssignManagerOpen] = useState(false);

    // Profile info section
    const [isEdit, setIsEdit] = useState(false);

    // Password
    const [showPasswords, setShowPasswords] = useState({
        current: false,
        new: false,
        confirm: false
    });

    const [preview, setProfileImg] = useState("");
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [profileImgFile, setProfileImgFile] = useState();

    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });


    const handlePostcode = (text) => {
        handleFormObjectChange('postal_code', text);
        setTimeout(() => {
            if (text === postcodeRef.current) {
                dispatch(getRegion({ postcode: text }));
                setIsLoading(true);
            }
        }, Helpers.searchInterval);
    }

    useEffect(() => {
        if (regionList?.data?.length > 0 && values?.postal_code) {
            handleFormObjectChange('region_id', regionList?.data?.map((region) => region.id));
        }
    }, [values?.postal_code, regionList])

    useEffect(() => {
        if (regionList?.code === "success" || regionList) {
            setIsLoading(false);
        }
    }, [regionList])


    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        setProfileImgFile(file);
        const reader = new FileReader();
        reader.onloadend = () => {
            handleFormObjectChange('profile_photo_path', reader.result); // base64 string
            handleFormObjectChange('profile_photo_name', file?.name); // base64 string
            handleFormObjectChange('remove_profile_photo', 1);
        };
        reader.readAsDataURL(file);
    };

    const handleStoreLogoChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onloadend = () => {
            handleFormObjectChange('cover_image', { ...values?.cover_image, file_base64: reader.result, file_name: file?.name });
            handleFormObjectChange('remove_cover_image', 1);
        };
        reader.readAsDataURL(file);
    };

    const convertTo24Hour = (time12h) => {
        if (!time12h) return '-1';

        const [time, modifier] = time12h.split(' ');
        let [hours, minutes] = time.split(':');

        if (hours === '12') {
            hours = '00';
        }

        if (modifier === 'PM' && hours !== '12') {
            hours = parseInt(hours, 10) + 12;
        }

        return `${hours.toString().padStart(2, '0')}:${minutes}`;
    };

    useEffect(() => {
        if (details && selected === "profile_info") {
            setFormValues({
                name: details?.name || "",
                email: details?.email || "",
                phone: details?.phone ? String(details.phone).trim().replace(/^65/, '') : "",
                profile_photo_path: details?.profile_photo_path,
                profile_photo_name: details?.profile_photo_name,
                remove_profile_photo: 0
            })

            if (!isEdit) {
                setProfileImg(details?.profile_photo_path)
            }
        }
    }, [details, selected, isEdit])

    useEffect(() => {
        postcodeRef.current = values?.postal_code || '';
    }, [values?.postal_code]);


    useEffect(() => {
        if (editUserProfile?.code === "success") {
            setNotification({
                open: true,
                msg: 'Profile updated successfully',
                type: 'success'
            })
            dispatch(resetProfileState());
            dispatch(verify_admin());
            setFormValues("")
        } else if (editUserProfile?.code === "failed" || editUserProfile?.code === "error" || editUserProfile?.code === "invalid_field") {
            setNotification({
                open: true,
                msg: getErrorMessage(editUserProfile),
                type: "error"
            });
            setIsLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editUserProfile])

    //branch 
    useEffect(() => {
        if (updateBranchArry?.code === "success") {
            setNotification({
                open: true,
                msg: 'Branch updated successfully',
                type: 'success'
            })
            dispatch(resetProfileState());
            dispatch(resetBranchActionState());
            dispatch(verify_admin());
            dispatch(getGeneral());
            setFormValues("")
        } else if (updateBranchArry?.code === "failed" || updateBranchArry?.code === "error" || updateBranchArry?.code === "invalid_field") {
            setNotification({
                open: true,
                msg: getErrorMessage(updateBranchArry),
                type: "error"
            });
            setIsLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateBranchArry])

    useEffect(() => {
        if (addBranchArry?.code === "success") {
            setNotification({
                open: true,
                msg: 'Branch added successfully',
                type: 'success'
            })
            dispatch(resetProfileState());
            dispatch(resetBranchActionState());
            dispatch(verify_admin());
            dispatch(getGeneral());
            setFormValues("")
        } else if (addBranchArry?.code === "failed" || addBranchArry?.code === "error" || addBranchArry?.code === "invalid_field") {
            setNotification({
                open: true,
                msg: getErrorMessage(addBranchArry),
                type: "error"
            });
            setIsLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [addBranchArry])

    useEffect(() => {
        if (delBranchArry?.code === "success") {
            setNotification({
                open: true,
                msg: 'Branch deleted successfully',
                type: 'success'
            })
            dispatch(resetProfileState());
            dispatch(resetBranchActionState());
            dispatch(verify_admin());
            dispatch(getGeneral());
            setFormValues("")
        } else if (delBranchArry?.code === "failed" || delBranchArry?.code === "error" || delBranchArry?.code === "invalid_field") {
            setNotification({
                open: true,
                msg: getErrorMessage(delBranchArry),
                type: "error"
            });
            setIsLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [delBranchArry])

    useEffect(() => {
        if (setSalesmanAsDefaultResponse?.code === "success") {
            setNotification({
                open: true,
                msg: "Default salesman set successfully",
                type: "success",
            });
            // setIsLoading(false);
            setDefaultOpen(false);
            setSelectedSalesman("");
            initData();
            dispatch(resetProfileActionState());
        } else if (setSalesmanAsDefaultResponse?.code && setSalesmanAsDefaultResponse?.code !== "success") {
            setIsLoading(false);
            setNotification({
                open: true,
                msg: setSalesmanAsDefaultResponse?.message || "Failed to set default salesman",
                type: "error",
            });
            dispatch(resetProfileActionState());
        }
    }, [setSalesmanAsDefaultResponse]);

    useEffect(() => {
        initData();
    }, [selected])

    useEffect(() => {
        if (selected === 'store_details' && details?.user_name) {
            setIsLoading(false);
        }
        if (selected === 'salesman' && Array.isArray(details) && details?.length >= 0) {
            setIsLoading(false);
        }
        if (selected === 'team_members' && Array.isArray(details?.members) && details?.members?.length >= 0) {
            setIsLoading(false);
        }
        if (selected === 'profile_info' && details?.status) {
            setIsLoading(false);
        }
        if (selected === 'password_security' && details?.user_name) {
            setIsLoading(false);
        } if (selected === 'branch' && branchDetails?.code === "success") {
            setIsLoading(false);
        }

    }, [details, selected, branchDetails])


    // const handleFormObjectChange = (key, value) => {
    //     setFormValues((prevValues) => ({
    //         ...prevValues,
    //         [key]: value
    //     }));
    // }


    useEffect(() => {
        if (createSalesmanResponse?.code === "success") {
            setNotification({
                open: true,
                msg: "Salesman added successfully",
                type: "success",
            });
            setAddSalesmanOpen(false);
            setIsEditSalesman(false);
            setFormValues(defaultValues);
            setSelectedSalesman("");
            setType('Add');
            initData();
            dispatch(resetProfileActionState());
        } else if (createSalesmanResponse?.code && createSalesmanResponse?.code !== "success") {
            setNotification({
                open: true,
                msg: createSalesmanResponse?.message || "Failed to add salesman",
                type: "error",
            });
            setIsLoading(false);
            // dispatch(resetProfileActionState());
        }
    }, [createSalesmanResponse]);

    useEffect(() => {
        if (inviteTeamMemberResponse?.code === "success") {
            setNotification({
                open: true,
                msg: "Invitation sent successfully",
                type: "success",
            });
            setInviteUserOpen(false);
            setFormValues(defaultValues);
            initData();
            dispatch(resetProfileActionState());
        } else if (inviteTeamMemberResponse?.code && inviteTeamMemberResponse?.code !== "success") {
            setIsLoading(false);
            setNotification({
                open: true,
                msg: inviteTeamMemberResponse?.message || "Failed to send invitation",
                type: "error",
            });
            // dispatch(resetProfileActionState());
        }
    }, [inviteTeamMemberResponse]);

    useEffect(() => {
        if (reinviteTeamMemberResponse?.code === "success") {
            setNotification({
                open: true,
                msg: "Invitation sent successfully",
                type: "success",
            });
            setReinviteOpen(false);
            initData();
            dispatch(resetProfileActionState());
        } else if (reinviteTeamMemberResponse?.code && reinviteTeamMemberResponse?.code !== "success") {
            setIsLoading(false);
            setNotification({
                open: true,
                msg: reinviteTeamMemberResponse?.message || "Failed to send invitation",
                type: "error",
            });
            // dispatch(resetProfileActionState());
        }
    }, [reinviteTeamMemberResponse]);

    useEffect(() => {
        if (removeInvitationResponse?.code === "success") {
            setNotification({
                open: true,
                msg: "Invitation removed successfully",
                type: "success",
            });
            setRemoveInvitationOpen(false);
            initData();
            dispatch(resetProfileActionState());
        } else if (removeInvitationResponse?.code && removeInvitationResponse?.code !== "success") {
            setIsLoading(false);
            setNotification({
                open: true,
                msg: removeInvitationResponse?.message || "Failed to remove invitation",
                type: "error",
            });
            // dispatch(resetProfileActionState());
        }
    }, [removeInvitationResponse]);


    useEffect(() => {
        if (deleteSalesmanResponse?.code === "success") {
            setNotification({
                open: true,
                msg: "Salesman removed successfully",
                type: "success",
            });
            setDeleteOpen(false);
            setSelectedSalesman("");
            initData();
            dispatch(resetProfileActionState());
        } else if (deleteSalesmanResponse?.code && deleteSalesmanResponse?.code !== "success") {
            setNotification({
                open: true,
                msg: deleteSalesmanResponse?.message || "Failed to remove salesman",
                type: "error",
            });
            setIsLoading(false);
            dispatch(resetProfileActionState());
        }
    }, [deleteSalesmanResponse]);

    useEffect(() => {
        if (removeTeamMemberResponse?.code === "success") {
            setNotification({
                open: true,
                msg: "Team member removed successfully",
                type: "success",
            });
            setRemoveMemberOpen(false);
            setSelectedMember(null);
            initData();
            dispatch(resetProfileActionState());
        } else if (removeTeamMemberResponse?.code && removeTeamMemberResponse?.code !== "success") {
            setNotification({
                open: true,
                msg: removeTeamMemberResponse?.message || "Failed to remove team member",
                type: "error",
            });
            setIsLoading(false);
            dispatch(resetProfileActionState());
        }
    }, [removeTeamMemberResponse]);


    useEffect(() => {
        if (editUserProfile?.code === "success" && selected === "store_details") {
            setNotification({
                open: true,
                msg: "Store details updated successfully",
                type: "success",
            });
            setIsEditStore(false);
            initData();
            dispatch(resetProfileState());
        } else if (editUserProfile?.code === "invalid_field") {
            setNotification({
                open: true,
                msg: editUserProfile?.message || "Failed to update store details",
                type: "error",
            });
        }
    }, [editUserProfile]);


    useEffect(() => {
        if (details && selected === "store_details") {
            setFormValues({
                store_name: details?.store_name,
                registration_number: details?.registration_number,
                short_business_description: details?.short_business_description,
                website_url: details?.website_url,
                profile_photo: details?.user_profile_photo_path,
                remove_banner_image: 0,
                banner_image: details?.banner_image_path || details?.banner_image_base64 ? [{ file: details?.banner_image_path, file_base64: details?.banner_image_base64, file_name: details?.banner_image_name }] : [],
                street_address: details?.address_line_1,
                apartment: details?.address_line_2,
                city: details?.city,
                country_id: details?.country_id,
                postal_code: details?.postal_code,
                region_id: details?.region?.map((x, idx) => x?.id) || [],
                google_map_link: details?.google_map_link,
                google_review_link: details?.google_review_link,
                display_google_review: details?.is_google_review_active === 1,
                remove_cover_image: 0,
                cover_image: { file: details?.cover_image_path, file_base64: details?.cover_image_base64, file_name: details?.cover_image_name },
                openingHours: details?.operation_hours?.map(item => ({
                    day: item.day_of_week,
                    isChecked: true,
                    open_time: convertTo24Hour(item.open_time),
                    close_time: convertTo24Hour(item.close_time)
                })) || []
            });
            if (details?.postal_code) {
                dispatch(getRegion({ postcode: details?.postal_code }));
            }
        }
    }, [details, selected]);

    useEffect(() => {
        if (editUserProfile?.code === "success" && selected === "team_members") {
            setNotification({
                open: true,
                msg: "Team member role updated successfully",
                type: "success",
            });
            setAssignManagerOpen(false);
            setSelectedMember(null);
            initData();
            dispatch(resetProfileState());
            // setIsLoading(false);
        }
        if (editUserProfile?.code === "success" && selected === "profile_info") {
            setNotification({
                open: true,
                msg: "Profile updated successfully",
                type: "success",
            });
            setIsEdit(false);
            initData();
            dispatch(resetProfileState());
            // setIsLoading(false);
        }
        if (editUserProfile?.code === "success" && selected === "password_security") {
            setNotification({
                open: true,
                msg: "Password updated successfully",
                type: "success",
            });
            setFormValues(prev => ({
                ...prev,
                current_password: "",
                new_password: "",
                new_password_confirmation: "",
            }));
            dispatch(resetProfileState());
            setIsLoading(false);
        }
        if (editUserProfile?.code === "success" && selected === "salesman") {
            setNotification({
                open: true,
                msg: "Salesman updated successfully",
                type: "success",
            });
            setAddSalesmanOpen(false);
            setFormValues(defaultValues);
            setSelectedSalesman("");
            setIsEditSalesman(false);
            setType('Add');
            dispatch(resetProfileState());
            initData();
        }

    }, [editUserProfile, selected]);


    useEffect(() => {
        if (Array.isArray(branchDetails?.data) && branchDetails?.data?.length > 0) {
            setBranches(branchDetails?.data.map(rate => ({ id: rate.id, value: rate.branch_name })));
        }
    }, [branchDetails])

    useEffect(() => {
        if (!currentAccount?.dealer_id) {
            setSelected("profile_info");
        }
    }, [currentAccount])


    const initData = () => {
        setIsLoading(true);
        if (selected !== "branch")
            dispatch(getProfileDataByTab({ tab: selected }));
        else {
            dispatch(getBranchListing());
        }
    }


    const handleTabChange = (tabName) => {
        setIsEditStore(false);
        setIsEdit(false);
        setIsEditSalesman(false);
        setAddSalesmanOpen(false);
        setInviteUserOpen(false);
        setRemoveMemberOpen(false);
        setAssignManagerOpen(false);
        setDeleteOpen(false);
        setDefaultOpen(false);

        setFormValues(defaultValues);

        setSelectedSalesman("");
        setSelectedMember(null);

        dispatch(resetProfileState());
        // initData();

        setSelected(tabName);
    };


    const handleFormObjectChange = (key, value, day) => {
        if (key === 'openingHours') {
            // Handle checkbox toggle
            setFormValues((prevValues) => {
                const currentHours = prevValues.openingHours || [];
                const existingIndex = currentHours.findIndex(item => item.day === value);

                if (existingIndex >= 0) {
                    // Day exists, toggle isChecked
                    const updatedHours = [...currentHours];
                    updatedHours[existingIndex] = {
                        ...updatedHours[existingIndex],
                        isChecked: !updatedHours[existingIndex].isChecked
                    };
                    return { ...prevValues, openingHours: updatedHours };
                } else {
                    // Day doesn't exist, add it
                    return {
                        ...prevValues,
                        openingHours: [...currentHours, {
                            day: value,
                            isChecked: true,
                            open_time: '-1',
                            close_time: '-1'
                        }]
                    };
                }
            });
        } else if (key === 'open_time' || key === 'close_time') {
            // Handle time selection
            setFormValues((prevValues) => {
                const currentHours = prevValues.openingHours || [];
                const existingIndex = currentHours.findIndex(item => item.day === day);

                if (existingIndex >= 0) {
                    const updatedHours = [...currentHours];
                    updatedHours[existingIndex] = {
                        ...updatedHours[existingIndex],
                        [key]: value
                    };
                    return { ...prevValues, openingHours: updatedHours };
                }
                return prevValues;
            });
        } else {
            setFormValues((prevValues) => ({
                ...prevValues,
                [key]: value
            }));
        }
    }

    const handleSaveStoreDetails = async () => {
        setIsLoading(true);

        let profilePhotoBase64 = null;
        let removeProfilePhoto = 0;
        if (values?.profile_photo === null) {
            removeProfilePhoto = 1;
        }

        let operationHours = [];
        if (values?.openingHours && values?.openingHours.length > 0) {
            operationHours = values.openingHours
                .filter(item => item.isChecked)
                .map(item => ({
                    day_of_week: item.day,
                    open_time: item.open_time,
                    close_time: item.close_time,
                    status: item.isChecked ? 1 : 0
                }));
        }
        let payload = {
            tab: "store_details",
            store_name: values?.store_name,
            registration_number: values?.registration_number,
            short_business_description: values?.short_business_description,
            website_url: values?.website_url,
            address_line_1: values?.street_address,
            address_line_2: values?.apartment || "",
            city: values?.city,
            country_id: values?.country_id,
            postal_code: values?.postal_code,
            region: values?.region_id,
            google_map_link: values?.google_map_link || "",
            google_review_link: values?.google_review_link || "",
            is_google_review_active: values?.display_google_review ? 1 : 0,
            // remove_profile_photo: removeProfilePhoto,
            remove_banner_image: values?.remove_banner_image || 0,
            remove_cover_image: values?.cover_image ? 0 : 1,
            operation_hours: operationHours
        };

        // if (profilePhotoBase64) {
        //     payload.user_profile_photo_path = profilePhotoBase64;
        //     payload.user_profile_photo_name = "store_logo.png";
        // }

        payload.banner_image_path = values?.banner_image?.[0]?.file_base64 || null;
        payload.banner_image_name = values?.banner_image?.[0]?.file_name || null;

        payload.cover_image_path = values?.cover_image?.file_base64 || null;
        payload.cover_image_name = values?.cover_image?.file_name || null;

        dispatch(updateProfile(payload));
    };

    const handlesubmit = async () => {
        setIsLoading(true);

        let payload = {
            tab: "profile_info",
            name: values?.name,
            email: values?.email,
            phone: 65 + values?.phone,
            remove_profile_photo: values?.remove_profile_photo,
            profile_photo_path: values?.profile_photo_path,
            profile_photo_name: values?.profile_photo_name,
        }

        dispatch(updateProfile(payload))
    }

    const handlePasswordSubmit = async () => {
        setIsLoading(true);

        let payload = {
            tab: "password",
            current_password: values?.current_password,
            new_password: values?.new_password,
            new_password_confirmation: values?.new_password_confirmation,
        }

        dispatch(updateProfile(payload))
    }

    const handleSaveSalesman = () => {
        setIsLoading(true);
        if (type === 'Add') {
            let payload = {
                location_id: values?.location,
                salesman_name: values?.salesmanName,
                phone: values?.phoneNumber ? '65' + String(values?.phoneNumber) : null,
            };
            dispatch(createSalesman(payload));
        } else if (type === 'Edit') {
            let payload = {
                tab: "salesman",
                salesman_id: selectedSalesman?.salesman_id,
                salesman_name: values?.salesmanName,
                phone: values?.phoneNumber ? '65' + String(values?.phoneNumber) : null,
                location_id: values?.location,
            };
            dispatch(updateProfile(payload));
        }
    };

    const handleSendInvitation = () => {
        setIsLoading(true);
        let payload = {
            email: values?.email,
        };
        dispatch(inviteTeamMember(payload));
    };

    const handleReinvite = () => {
        setIsLoading(true);
        let payload = {
            id: selectedMember?.id
        };
        dispatch(reinviteTeamMember(payload));
    };

    const handleRemoveInvitation = () => {
        setIsLoading(true);
        let payload = {
            id: selectedMember?.id
        };
        dispatch(removeTeamMemberInvitation(payload));
    };

    const handleDefault = () => {
        if (selectedSalesman?.salesman_id) {
            setIsLoading(true);
            dispatch(setSalesmanAsDefault({ id: selectedSalesman.salesman_id }));
        }
    };


    const handleAssignManager = () => {
        console.log("dfgfdg", selectedMember)
        if (selectedMember?.user_id) {
            setIsLoading(true);
            let payload = {
                action: "edit_team_member",
                tab: "team_members",
                dealer_user_id: selectedMember.id,
                is_manager: selectedMember?.role === "Manager" ? 0 : 1
            };
            dispatch(updateProfile(payload));
        }
    };


    const handleDelete = () => {
        if (selectedSalesman?.id) {
            dispatch(deleteSalesman({ id: selectedSalesman.id }));
        }
    };

    const handleRemoveMember = () => {
        if (selectedMember?.id) {
            dispatch(removeTeamMember({ id: selectedMember.id }));
        }
    };

    const header = [
        {
            Header: "Salesman name",
            accessor: (cellProps) => {
                return (<>{cellProps?.salesman_name || "-"} {cellProps?.is_default === 1 && <Chip style={{ backgroundColor: "#E7F2FC", color: "#3674B5", height: "25px", marginLeft: 2 }} label={cellProps?.is_default === 1 ? "Default" : ""} />}</>)
            },
        },
        {
            Header: "Branch",
            accessor: (cellProps) => {
                return (<div>{cellProps?.location_name || "-"}</div>)
            },
        },

        {
            Header: "Phone number",
            accessor: (cellProps) => {
                return (<div>{cellProps?.phone || "-"}</div>)
            },
        },
        {
            Header: " ",
            accessor: (cellProps) => {
                return (
                    <RenderPopOverButton
                        customTitle={<Icon icon="solar:menu-dots-bold" />}
                        items={[
                            { iconName: 'solar:flag-linear', label: 'Set as default', color: '#1D1B1B', permission: cellProps?.is_default == 0 && editable, onClick: () => { setSelectedSalesman(cellProps); setDefaultOpen(true) } },
                            {
                                iconName: 'solar:pen-linear', label: 'Edit Salesman', color: '#1D1B1B', permission: editable, onClick: () => {
                                    setSelectedSalesman(cellProps);
                                    setFormValues({
                                        salesmanName: cellProps?.salesman_name,
                                        phoneNumber: cellProps?.phone ? String(cellProps?.phone).trim().replace(/^65/, '') : '',
                                        location: cellProps?.location_id,
                                        is_featured: cellProps?.is_featured,
                                        sort_order: cellProps?.sort_order
                                    }); setAddSalesmanOpen(true); setType("Edit");
                                }
                            },
                            { iconName: 'solar:user-cross-linear', label: 'Remove salesman', color: '#D13536', permission: deletable, onClick: () => { setSelectedSalesman(cellProps); setDeleteOpen(true) } },
                        ]}
                    />
                )
            },
        },
    ]

    const teamMembersHeader = [
        {
            Header: "Name",
            accessor: (cellProps) => {
                return (<>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>{cellProps?.name || "-"}
                        {
                            cellProps?.user_id === userID &&
                            <Label.GeneralStatusLabel label={0} list={Helpers.profileTeamMemberVerificationStatus} marginLeft={"0px"} />
                        }
                        {/* {
                            cellProps?.status === "Invited" &&
                            <Label.GeneralStatusLabel label={2} list={Helpers.profileTeamMemberVerificationStatus} marginLeft={"0px"} />
                        } */}
                    </div>
                </>)
            },
        },
        {
            Header: "Role",
            accessor: (cellProps) => {
                return (cellProps?.role || "-")
            },
        },
        {
            Header: "Email address",
            accessor: (cellProps) => {
                return (<div>{cellProps?.email || "-"}</div>)
            },
        },
        {
            Header: "Status",
            accessor: (cellProps) => {
                return (<div><Label.GeneralStatusLabel label={cellProps.status} list={Helpers.profileTeamMemberStatus} marginLeft={"0px"} /></div>)
            },
        },
        {
            Header: " ",
            accessor: (cellProps) => {
                const options = [
                    {
                        iconName: cellProps?.role === "Manager" ? 'fluent:people-subtract-20-regular' : 'fluent:person-settings-20-regular', label: `${cellProps?.role === "Manager" ? 'Discharge manager role' : 'Assign as Manager'}`, color: '#454545', permission: editable,
                        onClick: () => {
                            setSelectedMember(cellProps); setAssignManagerOpen(true);
                        }
                    },

                    // { iconName: 'solar:lock-keyhole-minimalistic-unlocked-linear', label: 'Assign as manager', color: '#1D1B1B', permission: editable, onClick: () => { setSelectedMember(cellProps); setAssignManagerOpen(true); } },
                    { iconName: 'solar:user-cross-linear', label: 'Remove user', color: '#D13536', permission: deletable, onClick: () => { setSelectedMember(cellProps); setRemoveMemberOpen(true) } },
                ]
                const invitedOptions = [
                    { iconName: 'solar:mailbox-line-duotone', label: 'Resend invitation', color: '#1D1B1B', permission: editable, onClick: () => { setSelectedMember(cellProps); setReinviteOpen(true) } },
                    { iconName: 'solar:user-cross-linear', label: 'Remove user', color: '#D13536', permission: deletable, onClick: () => { setSelectedMember(cellProps); setRemoveInvitationOpen(true) } },
                ]
                const filteredOptions = cellProps?.status === "Invited" ? invitedOptions : options;
                return (
                    <>
                        {
                            (cellProps?.role !== "Owner" && cellProps?.role !== "owner") &&
                            <RenderPopOverButton //only role = manager can shows popoverbutton on the member row, status invited will also not showing popoverbutton, will set the condition during api integration
                                customTitle={<Icon icon="solar:menu-dots-bold" />}
                                items={filteredOptions}
                            />
                        }
                    </>
                )
            },
        },
    ]

    const handleLoanRateChange = (index, value) => {
        let updatedRates = [...branches];
        updatedRates[index].value = value;
        setBranches(updatedRates);
    }

    const handleDeleteLoanRate = (index, id) => {
        if (id) {
            setRemoveBranchesIds(prev => [...prev, id]);
        }
        setBranches(prev => prev.filter((_, i) => i !== index));
    }

    const handleSaveBranches = () => {
        setIsLoading(true);
        if (newBranchesIds.length > 0) {
            dispatch(createBranch({ branches: branches?.filter(item => !item.id).map(item => ({ branch_name: item.value })) })); // Assuming the API accepts an array of branch objects with branch_name
        }
        if (editedBranchesIds.length > 0) {
            dispatch(updateBranch({ branches: branches?.filter(item => item.id).map(item => ({ id: item.id, branch_name: item.value })) })); // Assuming the API accepts an array of branch objects with id and branch_name for updates
        }
        if (removeBranchesIds.length > 0) {
            setIsLoading(true);
            dispatch(deleteBranch({ ids: removeBranchesIds })); // Assuming the API accepts an array of IDs to delete
        }
    }

    const renderContent = () => {
        const handlePostcode = (text) => {
            handleFormObjectChange('postal_code', text);
            setTimeout(() => {
                if (text === postcodeRef.current) {
                    dispatch(getRegion({ postcode: postcodeRef.current }));
                }
            }, Helpers.searchInterval);
        }
        switch (selected) {
            case "store_details":
                return !isEditStore ? (
                    <>
                        {width > 768 ? (
                            <Stack spacing={0} style={{ display: "flex", justifyContent: "space-between", flexDirection: "row", alignItems: "center", }}>
                                <Stack display="flex" flexDirection="row" gap={2} alignItems="center" >
                                    <Avatar src={details?.cover_image_path} sx={{ width: 50, height: 50 }} />
                                    <div style={{ flexDirection: "column", display: "flex", }}>
                                        <span style={{ fontSize: "14px", fontWeight: 600 }}>{details?.store_name || "-"} <Chip label={details?.type || "Dealer"} style={{ color: "white", backgroundColor: "#D13536", height: "20px", marginLeft: 2, marginBottom: 2 }} /></span>
                                        <span className="text-muted">{details?.dealer_user_count || 0} members</span>
                                    </div>
                                </Stack>
                                <div>
                                    <CustomButton
                                        title={"View on marketplace"}
                                        paddingInline={25}
                                        padding={18}
                                        press={() => window.open(dealer_marketplace_url, '_blank')}
                                        width={"100%"}
                                        marginRight={10}
                                    />
                                </div>
                            </Stack>
                        ) : (

                            <Grid container sx={{ marginBottom: 2 }}>
                                <Stack spacing={2} style={{ display: "flex", justifyContent: "space-between", flexDirection: "row", alignItems: "center" }}>
                                    <Stack display="flex" flexDirection="row" gap={2} alignItems="center" >
                                        <img
                                            src={details?.cover_image_base64}
                                            alt="profile"
                                            width={64} height={64} style={{ borderRadius: "50%", objectFit: "cover" }}
                                        />
                                        <div style={{ flexDirection: "column", display: "flex", }}>
                                            <span style={{ fontSize: "16px", fontWeight: 600, }}>{details?.user_name || "-"} <Chip label={details?.type || "Dealer"} style={{ marginLeft: 2, color: "white", backgroundColor: "#D13536", height: "20px" }} /></span>
                                            <span className="text-muted">{details?.dealer_user_count || 0} members</span>
                                        </div>
                                    </Stack>
                                </Stack>

                                <Grid item xs={12} sx={{ marginTop: 2 }}>
                                    <CustomButton
                                        width={'100%'}
                                        height={'80%'}
                                        title={"View on marketplace"}
                                        press={() => window.open(dealer_marketplace_url, '_blank')}
                                    />
                                </Grid>
                            </Grid>
                        )}

                        <Grid container spacing={2} pt={2}>
                            <Grid item xs={12} display={"flex"} direction="column">
                                <span className="text-muted font-size-12 pb-1">Store name</span>
                                <span className="font-size-14">{details?.store_name || "-"}</span>
                            </Grid>
                            <Grid item xs={12} display={"flex"} direction="column">
                                <span className="text-muted font-size-12 pb-1">Registration number / UEN</span>
                                <span className="font-size-14">{details?.registration_number || "-"}</span>
                            </Grid>
                            <Grid item xs={12} display={"flex"} direction="column">
                                <span className="text-muted font-size-12 pb-1">Short business description</span>
                                <span className="font-size-14">{details?.short_business_description || "-"}</span>
                            </Grid>
                            <Grid item xs={12} display={"flex"} direction="column">
                                <span className="text-muted font-size-12 pb-1">Website URL</span>
                                <span className="font-size-14">{details?.website_url || "-"}</span>
                            </Grid>
                            <Grid item xs={12} display={"flex"} direction="column">
                                <span className="text-muted font-size-12 pb-1">Banner image</span>
                                {
                                    details?.banner_image_path ?
                                        <img
                                            className="clickable"
                                            alt="banner-image"
                                            style={{ width: 190, height: 120, objectFit: 'contain' }}
                                            src={details?.banner_image_path || "-"}
                                            onClick={() => { setSelectedFile(details?.banner_image_path); setAttachmentOpen(true) }}
                                        />
                                        : <div>No Image</div>
                                }
                            </Grid>
                            {/* <Grid item xs={12} display={"flex"} direction="column">
                                <span className="text-muted font-size-12 pb-1">Cover image</span>
                                <img alt="cover-image" style={{ width: 190, height: 120, objectFit: 'contain' }} src={details?.cover_image_path || "-"} />
                            </Grid> */}
                            <Grid item xs={12} display={"flex"} direction="column" spacing={2}>
                                <span className="text-muted font-size-12 pb-1">Operating hours</span>
                                <Stack spacing={1}>
                                    {
                                        dayList.map((day, index) => {
                                            const hours = details?.operation_hours?.find(item => item.day_of_week === day);
                                            return (
                                                <div key={index} className="font-size-14 d-flex" spacing={1}>
                                                    <span style={{ minWidth: '160px' }}>{day}</span>
                                                    <span>{hours ? `${hours.open_time} - ${hours.close_time}` : 'Closed'}</span>
                                                </div>
                                            )
                                        })
                                    }
                                </Stack>
                            </Grid>
                            <Grid item xs={12} display={"flex"} direction="column" spacing={2}>
                                <span className="text-muted font-size-12 pb-1">Address</span>
                                <iframe
                                    title="google-map"
                                    width="240"
                                    height="136"
                                    src={`https://maps.google.com/maps?width=100%25&height=600&hl=en&q=${details?.latitude},${details?.longitude}&t=&z=14&ie=UTF8&iwloc=B&output=embed`}
                                />
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: width > 768 ? 'center' : 'flex-start', gap: '4px', marginTop: "2px" }}>
                                    <Icon icon="solar:map-point-linear" width={width > 768 ? 14 : 22} height={14} style={{ marginTop: width > 768 ? 0 : 5 }} />
                                    <div>
                                        {details?.address_line_1 || '-'}
                                        {details?.address_line_2 && <div>{details?.address_line_2}</div>}
                                    </div>
                                </div>
                            </Grid>

                            <Grid item xs={12} display={"flex"} direction="column" spacing={2}>
                                <span className="text-muted font-size-12 pb-1">Region</span>
                                <div>{details?.region?.name}</div>
                            </Grid>

                            <Grid item xs={12} display={"flex"} direction="column" spacing={2}>
                                <span className="text-muted font-size-12 pb-1">Google review link</span>
                                <div>{details?.google_review_link || '-'}</div>
                            </Grid>

                            <Grid item xs={12} display={"flex"} direction="column" spacing={2}>
                                <span className="text-muted font-size-12 pb-1">Google review status</span>
                                <div><Label.GeneralStatusLabel label={details?.google_review_status} list={Helpers.reviewStatus} marginLeft={"0px"} /></div>
                            </Grid>

                            <Grid item xs={12} pt={2}>
                                <CustomButton
                                    title="Edit"
                                    press={() => {
                                        setIsEditStore(true);
                                    }}
                                    textColor={"#808588"}
                                    backgroundColor={"#F9F9F9"}
                                    borderStyle={"#F9F9F9"}
                                    height={"36px"}
                                    width={"97px"}
                                />
                            </Grid>
                        </Grid>
                    </>) : (<div>
                        <Stack spacing={2} pb={3} style={{ display: "flex", justifyContent: "space-between", flexDirection: "row", alignItems: "center" }}>
                            <Stack display="flex" flexDirection="row" gap={2} alignItems="center">
                                <div style={{ position: 'relative' }}>
                                    <Avatar
                                        src={values?.cover_image?.file_base64}
                                        sx={{ width: 50, height: 50 }}
                                    />
                                </div>
                                <Stack direction="row" gap={2}>
                                    <CustomButton
                                        title="Upload"
                                        press={() => {
                                            document.getElementById('store-logo-upload').click();
                                        }}
                                        backgroundColor="#1D1B1B"
                                        textColor="white"
                                        height="36px"
                                        width="auto"
                                    />
                                    <input
                                        id="store-logo-upload"
                                        type="file"
                                        accept="image/*"
                                        style={{ display: 'none' }}
                                        onChange={handleStoreLogoChange}
                                    />
                                    <CustomButton
                                        title="Remove"
                                        press={() => {
                                            handleFormObjectChange('cover_image', null);
                                            handleFormObjectChange('remove_cover_image', 1);
                                        }}
                                        backgroundColor="#F9F9F9"
                                        textColor="#808588"
                                        height="36px"
                                        width="auto"
                                    />
                                </Stack>
                            </Stack>
                        </Stack>


                        <Grid container spacing={1}>
                            <Grid item xs={width > 768 ? 6 : 12}>
                                <CustomTextField
                                    title="Store name"
                                    values={values?.store_name || ''}
                                    onChange={(e) => handleFormObjectChange('store_name', e)}
                                    placeholder="Enter store name"
                                    paddingBlock="8px"
                                    error={error?.store_name}
                                />
                            </Grid>

                            <Grid item xs={width > 768 ? 6 : 12}>
                                <CustomTextField
                                    title="Registration number / UEN"
                                    values={values?.registration_number || ''}
                                    onChange={(e) => handleFormObjectChange('registration_number', e)}
                                    placeholder="Enter registration number"
                                    paddingBlock="8px"
                                    error={error?.registration_number}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <CustomTextField
                                    title="Short business description"
                                    values={values?.short_business_description || ''}
                                    onChange={(e) => handleFormObjectChange('short_business_description', e)}
                                    placeholder="Enter short business description"
                                    paddingBlock="8px"
                                    multiline
                                    rows={3}
                                    error={error?.short_business_description}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <CustomTextField
                                    values={values?.website_url || ''}
                                    onChange={(e) => handleFormObjectChange('website_url', e)}
                                    placeholder="Website URL"
                                    paddingBlock="8px"
                                    sx={{ marginBottom: 1 }}
                                    error={error?.website_url}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                {/* <Stack spacing={1}> */}
                                <span style={{ fontSize: 14, fontWeight: 500 }}>Banner Image</span>
                                <UploadProductImagesNew
                                    showLimit={false}
                                    displayFiles={false}
                                    values={values?.banner_image || []}
                                    setFormValues={(e) => {
                                        handleFormObjectChange('banner_image', e);
                                        // if (details?.banner_image_path) {
                                        //     handleFormObjectChange('remove_banner_image', 1);
                                        // }
                                    }}
                                    maxFile={10}
                                    maxFileSize={10}
                                    md={3}
                                    sm={6}
                                    xs={12}
                                    multiple={false}
                                    setNotification={setNotification}
                                    images={true}
                                    windowWidth={width}
                                />
                                {error?.banner_image_path && (
                                    <span style={{ color: '#D13536', fontSize: 12 }}>
                                        {error?.banner_image_path[0]}
                                    </span>
                                )}
                                {/* </Stack> */}
                            </Grid>

                            {/* <Grid item xs={12}>
                                <span style={{ fontSize: 14, fontWeight: 500 }}>Cover image</span>
                                <UploadProductImagesNew
                                    showLimit={false}
                                    displayFiles={false}
                                    values={values?.cover_image || []}
                                    setFormValues={(e) => {
                                        handleFormObjectChange('cover_image', e);
                                        if (details?.cover_image_path) {
                                            handleFormObjectChange('remove_cover_image', 1);
                                        }
                                    }}
                                    maxFile={10}
                                    maxFileSize={10}
                                    md={3}
                                    sm={6}
                                    xs={12}
                                    multiple={false}
                                    setNotification={setNotification}
                                    images={true}
                                    windowWidth={windowWidth}
                                />
                                {error?.cover_image_path && (
                                    <span style={{ color: '#D13536', fontSize: 12 }}>
                                        {error?.cover_image_path[0]}
                                    </span>
                                )}
                            </Grid> */}

                            <Grid item xs={12} mt={2}>
                                <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 4 }}>Opening hours</div>
                                <div style={{ fontSize: 14, color: '#808588' }}>Set the workshop/office working hours to show on your profile page</div>
                            </Grid>
                            {
                                dayList.map((day, idx) => {
                                    const matchedIndex = values?.openingHours?.findIndex((item) => item?.day === day && item?.isChecked);
                                    return (
                                        <Grid item container xs={12} sm={12} spacing={2}>
                                            <Grid item xs={3} sm={3} className="d-flex align-items-center">
                                                <CheckBox label={day} labelMarginLeft={width > 768 ? 20 : 3} values={values?.openingHours?.find((item) => item?.day === day)?.isChecked || false} onChange={(e) => { handleFormObjectChange('openingHours', day) }} />
                                            </Grid>
                                            <Grid item xs={4} sm={4}>
                                                <CustomSelect
                                                    width={width > 768 ? undefined : 100}
                                                    height={width > 768 ? undefined : 70}
                                                    title={'Opening time'}
                                                    values={values?.openingHours?.find((item) => item?.day === day && item?.isChecked)?.open_time || '-1'}
                                                    data={Helpers.timeList}
                                                    disabled={!(values?.openingHours?.find((item) => item?.day === day && item?.isChecked))}
                                                    onChange={(e) => handleFormObjectChange('open_time', e, day)}
                                                    placeholder={'Opening time'}
                                                    error={matchedIndex > -1 ? error?.[`operation_hours.${matchedIndex}.open_time`] : null}
                                                    isMobile={true}
                                                />
                                            </Grid>
                                            <Grid item xs={1} sm={1} className="d-flex align-items-center justify-content-center">to</Grid>
                                            <Grid item xs={2} sm={4}>
                                                <CustomSelect
                                                    width={width > 768 ? undefined : 100}
                                                    height={width > 768 ? undefined : 70}
                                                    values={values?.openingHours?.find((item) => item?.day === day && item?.isChecked)?.close_time || '-1'}
                                                    data={Helpers.timeList}
                                                    disabled={!(values?.openingHours?.find((item) => item?.day === day && item?.isChecked))}
                                                    onChange={(e) => handleFormObjectChange('close_time', e, day)}
                                                    placeholder={'Closing time'}
                                                    title={'Closing time'}
                                                    error={matchedIndex > -1 ? error?.[`operation_hours.${matchedIndex}.close_time`] : null}
                                                    isMobile={true}
                                                />
                                            </Grid>
                                        </Grid>
                                    )
                                })
                            }

                            <Grid item xs={12} mt={2}>
                                <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 1 }}>Branch</div>
                                <div style={{ fontSize: 14, color: '#808588', }}>Add your company address</div>
                            </Grid>

                            <Grid item xs={12}>
                                <CustomTextField
                                    title="Street address"
                                    values={values?.street_address || ''}
                                    onChange={(e) => handleFormObjectChange('street_address', e)}
                                    placeholder="Enter street address"
                                    paddingBlock="8px"
                                    error={error?.address_line_1}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <CustomTextField
                                    title={"Apartment, building, floor, unit"}
                                    isOptional={true}
                                    values={values?.apartment || ''}
                                    onChange={(e) => handleFormObjectChange('apartment', e)}
                                    placeholder="Apartment, building, floor, unit, etc"
                                    paddingBlock="8px"
                                    sx={{ marginBottom: 1 }}
                                    error={error?.apartment}
                                />
                            </Grid>

                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                <CustomTextField
                                    values={values?.postal_code}
                                    onChange={(e) => handlePostcode(e)}
                                    title={'Postal Code'}
                                    placeholder={'Postal Code'}
                                    type={'number'}
                                    error={error?.postal_code}
                                />
                            </Grid>
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                <CustomTextField
                                    values={values?.region_id?.length > 0 ? values.region_id.map(id => regionList?.data?.find(region => region.id === id)?.name).filter(Boolean).join(', ') : ''}
                                    // onChange={(e) => { console.log('helloooo', e, regionList?.data); handleFormObjectChange('region', e) }}
                                    title={'Region'}
                                    placeholder={'Region'}
                                    data={regionList?.data || []}
                                    // labelName={'name'}
                                    // valueName={'id'}
                                    disabled={true}
                                    error={error?.region_id}
                                />
                            </Grid>
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                <CustomTextField
                                    values={values?.city}
                                    // data={stateList?.find(state => state.id === values?.state_id)?.cities || []}
                                    onChange={(e) => handleFormObjectChange('city', e)}
                                    title={'City'}
                                    placeholder={'City'}
                                    error={error?.city}
                                />
                            </Grid>
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                <CustomSelect
                                    values={values?.country_id || '-1'}
                                    data={countryList || []}
                                    onChange={(e) => handleFormObjectChange('country_id', e)}
                                    title={'Country'}
                                    placeholder={'Country'}
                                    labelName={'name'}
                                    valueName={'id'}
                                    error={error?.country_id}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <CustomTextField
                                    title="Google map link"
                                    values={values?.google_map_link || ''}
                                    isOptional={true}
                                    onChange={(e) => handleFormObjectChange('google_map_link', e)}
                                    placeholder="Enter Google map link"
                                    paddingBlock="8px"
                                    error={error?.google_map_link}
                                />
                            </Grid>

                            <Grid item xs={12} mt={2}>
                                <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 4 }}>Google Review</div>
                                <div style={{ fontSize: 14, color: '#808588' }}>Paste your Google Reviews URL from Google Business Profile.</div>
                            </Grid>

                            <Grid item xs={12}>
                                <CustomTextField
                                    title="Google review place ID"
                                    isOptional={true}
                                    values={values?.google_review_link || ''}
                                    onChange={(e) => handleFormObjectChange('google_review_link', e)}
                                    placeholder="Enter Google review link"
                                    paddingBlock="8px"
                                />
                            </Grid>

                            <Grid item xs={12} sm={12} sx={{ marginTop: 1 }}>
                                <CheckBox
                                    label="Display google review section on dealer profile"
                                    labelMarginLeft={8}
                                    labelWhiteSpace={'normal'}
                                    values={values?.display_google_review || false}
                                    onChange={(e) => handleFormObjectChange('display_google_review', !values?.display_google_review)}
                                    fontSize={14}
                                />
                            </Grid>

                            <Grid item xs={12} pt={2}>
                                <Stack direction="row" spacing={2} gap={1}>
                                    <CustomButton
                                        title="Save changes"
                                        press={() => {
                                            handleSaveStoreDetails();
                                        }}
                                        backgroundColor="#1D1B1B"
                                        textColor="white"
                                        height="36px"
                                        width="150px"
                                    />
                                    <CustomButton
                                        title="Cancel"
                                        press={() => {
                                            setIsEditStore(false);
                                            // Reset form values if needed
                                        }}
                                        backgroundColor="#F9F9F9"
                                        textColor="#808588"
                                        height="36px"
                                        width="115px"
                                        borderStyle={"none"}
                                    />
                                </Stack>
                            </Grid>
                        </Grid>
                    </div>);
            case 'branch':
                return <>
                    <Box sx={{ fontWeight: 600, fontSize: 16, mb: 1 }}>Branch</Box>
                    {/* <Box sx={{ color: '#808588', fontSize: 14, mb: 2 }}>
                        Set the loan interest rate list.
                    </Box> */}
                    <Box>
                        {
                            branches?.map((rate, index) => (
                                <div className="d-flex align-items-center">
                                    <div className="d-grid">
                                        <CustomTextField
                                            values={rate?.value}
                                            onChange={(e) => { handleLoanRateChange(index, e); rate?.id && setEditedBranchesIds(prev => [...prev, rate?.id]) }}
                                            placeholder={'Branch name'}
                                            type="text"
                                            error={branchError?.[`branch_names.0.branch_name`]}
                                        />
                                    </div>
                                    <ButtonBase style={{ marginLeft: 10, padding: 5, paddingInline: 10, borderRadius: 7 }} onClick={() => { handleDeleteLoanRate(index, rate?.id) }} >
                                        <Icon icon="ri-delete-bin-6-line" color='#F65151' width={20} height={20} />
                                    </ButtonBase>
                                </div>
                            ))
                        }

                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1, mt: 2 }}>
                        <CustomButton
                            title={'Add'}
                            press={() => { setBranches(prev => [...prev, { value: '' }]); setNewBranchesIds(prev => [...prev, { value: '' }]) }}
                        />
                        <CustomButton title={'Save'} disabled={newBranchesIds?.length <= 0 && editedBranchesIds?.length <= 0 && removeBranchesIds?.length <= 0} press={() => { (newBranchesIds?.length > 0 || editedBranchesIds?.length > 0 || removeBranchesIds?.length > 0) && handleSaveBranches() }} />
                    </Box>
                </>
            case "salesman":
                return <div>
                    <Stack spacing={2} pb={width > 768 ? 2 : 0} style={{ display: "flex", justifyContent: "space-between", flexDirection: "row", alignItems: "center" }}>
                        <span style={{ fontSize: "16px", fontWeight: 600 }}>Salesman</span>
                        <div className="m-0 p-0">
                            <CustomButton
                                title={width > 768 ? "Add new salesman" : "Add salesman"}
                                press={() => {
                                    setFormValues(defaultValues);
                                    setSelectedSalesman("");
                                    setType('Add');
                                    if (width > 768) {
                                        setAddSalesmanOpen(true);
                                    } else {
                                        setIsEditSalesman(true);
                                    }
                                }}
                            />
                        </div>
                    </Stack>
                    {width > 768 ? (
                        <Table
                            header={header}
                            data={Array.isArray(details) ? details : []}
                            pageSize={10}
                            totalPage={1}
                            headerBackground={"#F5F5F5"}
                            headerTitleColor={"#808588"}
                        />
                    ) : (
                        !isEditSalesman ? (
                            <div>
                                {Array.isArray(details) && details.length > 0 ? (
                                    details?.map((salesman, index) => (
                                        <div key={index} className="mt-3 dashboard-card">
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                                <div style={{ flex: 1 }}>
                                                    <div style={{ fontSize: '16px', fontWeight: 600, marginBottom: '8px' }}>
                                                        {salesman?.salesman_name || '-'}
                                                    </div>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#808588', fontSize: '14px', marginBottom: '5px' }}>
                                                        <Icon icon="solar:map-point-linear" width={16} height={16} />
                                                        <span>{salesman.location_id ? dealer_branches?.find((option) => option.id === salesman.location_id)?.name : '-'}</span>
                                                    </div>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#808588', fontSize: '14px' }}>
                                                        <Icon icon="solar:phone-linear" width={16} height={16} />
                                                        <span>{salesman?.phone || '-'}</span>
                                                    </div>
                                                </div>
                                                <div style={{ display: 'flex', gap: '12px', marginLeft: '16px' }}>
                                                    <Icon
                                                        icon="solar:pen-linear"
                                                        width={20}
                                                        height={20}
                                                        style={{ cursor: 'pointer', color: '#808588' }}
                                                        onClick={() => {
                                                            setSelectedSalesman(salesman);
                                                            setFormValues({
                                                                salesmanName: salesman?.salesman_name,
                                                                phoneNumber: salesman?.phone,
                                                                location: salesman?.location_id,
                                                            });
                                                            setIsEditSalesman(true);
                                                            setType("Edit");
                                                        }}
                                                    />
                                                    <Icon
                                                        icon="solar:trash-bin-trash-linear"
                                                        width={20}
                                                        height={20}
                                                        style={{ cursor: 'pointer', color: '#ef4444' }}
                                                        onClick={() => {
                                                            setSelectedSalesman(salesman);
                                                            setDeleteOpen(true);
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    ))) : (<div style={{
                                        marginTop: '16px',
                                        padding: '50px 20px',
                                        border: '2px dashed #E0E0E0',
                                        borderRadius: '8px',
                                        textAlign: 'center',
                                        backgroundColor: '#FAFAFA'
                                    }}>
                                        <Icon
                                            icon="solar:file-text-linear"
                                            width={48}
                                            height={48}
                                            style={{ color: '#D0D0D0', marginBottom: '12px' }}
                                        />
                                        <div style={{ color: '#A0A0A0', fontSize: '14px' }}>
                                            No added salesman yet
                                        </div>
                                    </div>)}
                            </div>
                        ) : (
                            <div className="mt-3 dashboard-card">
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <CustomTextField
                                            title="Salesman"
                                            values={values?.salesmanName}
                                            onChange={(e) => handleFormObjectChange('salesmanName', e)}
                                            placeholder="Enter salesman name"
                                            paddingBlock="8px"
                                            error={error?.salesman_name}
                                        />
                                    </Grid>

                                    <Grid item xs={12}>
                                        <CustomSelect
                                            title="Branch"
                                            placeholder="Choose a branch"
                                            values={values?.location || '-1'}
                                            onChange={(value) => handleFormObjectChange('location', value)}
                                            data={dealer_branches || []}
                                            valueName="id"
                                            labelName="name"
                                            error={error?.location_id}
                                        />
                                    </Grid>

                                    <Grid item xs={12}>
                                        <CustomTextField
                                            title="Contact"
                                            values={values?.phoneNumber}
                                            onChange={(e) => handleFormObjectChange('phoneNumber', e)}
                                            placeholder="Enter phone number"
                                            type={'phone'}
                                            InputProps={{
                                                startAdornment: <div style={{ paddingLeft: 6, paddingRight: 10 }}>+65</div>,
                                            }}
                                            paddingBlock="8px"
                                            error={error?.phone}
                                        />
                                    </Grid>

                                    <Grid item xs={12} pt={2} sx={{ marginTop: 2 }}>
                                        <Stack direction="row" spacing={2} gap={2}>
                                            <CustomButton
                                                title="Cancel"
                                                press={() => {
                                                    setIsEditSalesman(false);
                                                    setSelectedSalesman("");
                                                    setFormValues();
                                                    setType('Add');
                                                }}
                                                backgroundColor="#F9F9F9"
                                                textColor="#808588"
                                                height="36px"
                                                width="115px"
                                            />
                                            <CustomButton
                                                title="Save"
                                                press={() => {
                                                    handleSaveSalesman();
                                                    // setIsEditSalesman(false);
                                                }}
                                                backgroundColor="#1D1B1B"
                                                textColor="white"
                                                height="36px"
                                                width="150px"
                                            />
                                        </Stack>
                                    </Grid>
                                </Grid>
                            </div>)
                    )}
                    <AppDialog
                        open={addSalesmanOpen}
                        close={() => { setAddSalesmanOpen(false); setSelectedSalesman(""); setFormValues(); setTimeout(() => { setType('Add'); dispatch(resetProfileActionState()); }, 200); }}
                        title={type === 'Edit' ? 'Edit salesman' : 'Add new salesman'}
                        positiveTitle={type === 'Edit' ? 'Save changes' : 'Confirm'}
                        positivePress={() => { handleSaveSalesman(); }}
                        negativeTitle={'Cancel'}
                        negativePress={() => { setAddSalesmanOpen(false); setSelectedSalesman(""); setFormValues(); setTimeout(() => { setType('Add'); dispatch(resetProfileActionState()); }, 200); }}
                        negativeButtonStyle={{ color: "#808588", backgroundColor: "#F9F9F9", border: "0px solid black", width: "auto", borderRadius: "20px" }}
                        width={'30%'}
                        isMobile={width <= 768 ? true : false}
                        mobileSizeModalMaxHeight={"80%"}
                    >
                        <Grid container spacing={1}>
                            {type !== "Edit" && (
                                <Grid item xs={12}>
                                    <div className="text-muted">Enter the salesman info to add them to {currentAccount?.company_name || "-"}.</div>
                                </Grid>
                            )}

                            <Grid item xs={12}>
                                <CustomTextField
                                    title="Salesman name"
                                    values={values?.salesmanName}
                                    onChange={(e) => handleFormObjectChange('salesmanName', e)}
                                    placeholder="Enter salesman name"
                                    paddingBlock="8px"
                                    error={error?.salesman_name}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <CustomTextField
                                    title="Phone Number"
                                    values={values?.phoneNumber}
                                    onChange={(e) => handleFormObjectChange('phoneNumber', e)}
                                    placeholder="Enter phone number"
                                    paddingBlock="8px"
                                    type="phone"
                                    InputProps={{
                                        startAdornment: <div style={{ paddingLeft: 6, paddingRight: 10 }}>+65</div>,
                                    }}
                                    error={error?.phone}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <CustomSelect
                                    title="Branch"
                                    placeholder="Choose a Branch"
                                    values={values?.location}
                                    onChange={(value) => handleFormObjectChange('location', value)}
                                    data={dealer_branches}
                                    valueName="id"
                                    labelName="branch_name"
                                    error={error?.location_id}
                                />
                            </Grid>
                        </Grid>
                    </AppDialog>

                    <AppDialog
                        open={defaultOpen}
                        close={() => setDefaultOpen(false)}
                        title={'Set as default'}
                        positiveTitle={'Set as default'}
                        positiveButtonStyle={{ color: "white", borderRadius: "20px", backgroundColor: "black", border: "1px solid black", width: width > 768 ? "auto" : "50%", }}
                        negativeButtonStyle={{ backgroundColor: "#F9F9F9", color: "#808588", border: "none", borderRadius: "20px", width: width > 768 ? "auto" : "50%" }}
                        negativeTitle={'Cancel'}
                        positivePress={() => handleDefault()}
                        negativePress={() => setDefaultOpen(false)}
                        width={'30%'}
                        isMobile={width <= 768 ? true : false}
                    >
                        <Grid container>
                            <Grid item xs={12}>
                                <div className="" style={{ fontSize: width > 768 ? undefined : 15 }}>Are you sure you want to set <strong>{"salesman name"}</strong> as the <strong>default contact person</strong> for this dealer?</div>
                            </Grid>

                            <Grid container style={{ marginTop: '20px', border: "none", backgroundColor: "#F0F0F0", padding: "15px", borderRadius: "8px", marginBottom: "20px", borderLeft: "1px solid #1D1B1B" }}>
                                <Grid item xs={1} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <div style={{ border: "1px solid white", borderRadius: "100px", display: "inline-flex", padding: "4px", backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', width: '32px', height: '32px', }}>
                                        <Icon icon="solar:lightbulb-linear" />
                                    </div>
                                </Grid>
                                <Grid item xs={11} style={{ display: 'flex', alignItems: 'center', paddingLeft: 8 }}>
                                    Once confirmed, this salesman will appear as the primary contact on all new adverts created
                                </Grid>
                            </Grid>
                        </Grid>
                    </AppDialog>

                    {/* Delete modal for salesman*/}
                    <DeleteModal
                        open={deleteOpen}
                        onClose={() => setDeleteOpen(false)}
                        submit={handleDelete}
                        title='Remove Salesman'
                        message={'Are you sure you want to remove this salesman from your team?'}
                        positiveTitle='Remove'
                        positiveButtonStyle={{
                            backgroundColor: '#D13536',
                            color: "white",
                            border: "none",
                            borderRadius: "20px",
                            width: width > 768 ? "auto" : "50%",
                        }}
                        negativeButtonStyle={{
                            width: width > 768 ? "auto" : "50%",
                            color: "#808588",
                            backgroundColor: "#F9F9F9",
                            border: "0px solid black",
                            borderRadius: "20px",
                        }}
                        close={() => setDeleteOpen(false)}
                        width={"30%"}
                        isMobile={width <= 768 ? true : false}
                        mobileSizeModalMaxHeight={"43vh"}
                    />
                </div>;
            case 'team_members':
                return <div>
                    <Stack spacing={2} pb={2} style={{ display: "flex", justifyContent: "space-between", flexDirection: "row", alignItems: "center" }}>
                        {width > 768 ? (<span style={{ fontSize: "16px", fontWeight: 600 }}>Team Members ({details?.dealer_user_count || '-'})</span>) : (<span style={{ fontSize: "14px", fontWeight: 600 }}>Team Members</span>)}
                        <div className="m-0 p-0">
                            <CustomButton
                                title={width > 768 ? "Invite new user" : "Invite new users"}
                                press={() => setInviteUserOpen(true)}
                            />
                        </div>
                    </Stack>
                    {width > 768 ? (
                        <Table
                            header={teamMembersHeader}
                            data={details?.members || []}
                            pageSize={details?.members?.length || 10}
                            totalPage={1}
                            headerBackground={"#F5F5F5"}
                            headerTitleColor={"#808588"}
                        />
                    ) : (
                        <div>
                            {Array.isArray(details?.members) && details?.members?.length > 0 ? details?.members?.map((teamMember, index) => (
                                <div key={index} className="mt-3 dashboard-card">
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                        <div style={{ flex: 1 }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '16px', fontWeight: 600, marginBottom: '8px' }}>
                                                <span>{teamMember?.name || '-'}</span>
                                                <Label.GeneralStatusLabel label={teamMember.status} list={Helpers.profileTeamMemberStatus} marginLeft={"0px"} />
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#808588', fontSize: '14px', marginBottom: '5px' }}>
                                                <Icon icon="fluent:slide-text-person-20-regular" width={16} height={16} />
                                                <span>{teamMember?.role || '-'}</span>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', color: '#808588', fontSize: '14px' }}>
                                                <Icon icon="fluent:mail-20-regular" width={16} height={16} />
                                                <span>{teamMember?.email || '-'}</span>
                                            </div>
                                        </div>
                                        {
                                            teamMember?.user_id !== userID && teamMember?.status !== 'Invited' &&
                                            <div style={{ display: 'flex', gap: '12px', marginLeft: '16px', alignItems: 'center', height: '-webkit-fill-available' }}>
                                                <Icon
                                                    icon="solar:lock-keyhole-minimalistic-unlocked-linear"
                                                    width={20}
                                                    height={20}
                                                    style={{ cursor: 'pointer', color: '#808588' }}
                                                    onClick={() => {
                                                        setSelectedMember(teamMember);
                                                        setAssignManagerOpen(true);
                                                    }}
                                                />
                                                <Icon
                                                    icon="solar:user-cross-linear"
                                                    width={20}
                                                    height={20}
                                                    style={{ cursor: 'pointer', color: '#ef4444' }}
                                                    onClick={() => {
                                                        setSelectedMember(teamMember);
                                                        setRemoveMemberOpen(true)
                                                    }}
                                                />
                                            </div>
                                        }
                                    </div>
                                </div>
                            )) :
                                <div className="d-flex justify-content-center align-items-center subheader-2" style={{ height: 150 }}>No members found</div>
                            }

                        </div>
                    )}
                    <AppDialog
                        open={reinviteOpen}
                        close={() => setReinviteOpen(false)}
                        title={'Reinvite member to team'}
                        positiveTitle={'Send invitation'}
                        negativeTitle={'Cancel'}
                        positivePress={() => handleReinvite()}
                        negativePress={() => setReinviteOpen(false)}
                        width={'30%'}
                        isMobile={width <= 768 ? true : false}
                        mobileSizeModalMaxHeight={"55%"}
                    >
                        Are you sure you want to resend the invitation email to <strong>{selectedMember?.email || '-'}</strong> to join the team?
                    </AppDialog>
                    <AppDialog
                        open={removeInvitationOpen}
                        close={() => setRemoveInvitationOpen(false)}
                        title={'Remove invitation'}
                        positiveTitle={'Remove'}
                        negativeTitle={'Cancel'}
                        positivePress={() => handleRemoveInvitation()}
                        negativePress={() => setRemoveInvitationOpen(false)}
                        width={'30%'}
                        isMobile={width <= 768 ? true : false}
                        mobileSizeModalMaxHeight={"55%"}
                    >
                        Are you sure you want to remove the invitation for <strong>{selectedMember?.email || '-'}</strong> to join the team?
                    </AppDialog>
                    <AppDialog
                        open={inviteUserOpen}
                        close={() => setInviteUserOpen(false)}
                        title={'Invite new member to team'}
                        positiveTitle={'Send invitation'}
                        positiveButtonStyle={{ color: "white", borderRadius: "20px", backgroundColor: "black", border: "1px solid black", width: width > 768 ? "auto" : "50%", }}
                        negativeButtonStyle={{ backgroundColor: "#F9F9F9", color: "#808588", border: "none", borderRadius: "20px", width: width > 768 ? "auto" : "50%" }}
                        negativeTitle={'Cancel'}
                        positivePress={() => handleSendInvitation(false)}
                        negativePress={() => setInviteUserOpen(false)}
                        width={'30%'}
                        isMobile={width <= 768 ? true : false}
                        mobileSizeModalMaxHeight={"55%"}
                    >
                        <Grid container>
                            <Grid item xs={12}>
                                <div className="text-muted" style={{ fontSize: width > 768 ? undefined : 15 }}>Enter the member's email address to invite them to {currentAccount?.company_name}.</div>
                            </Grid>

                            <Grid item xs={12} sx={{ marginTop: width > 768 ? undefined : 2 }}>
                                <CustomTextField
                                    title="Email address"
                                    values={values?.email}
                                    onChange={(e) => handleFormObjectChange('email', e)}
                                    placeholder="Enter email address"
                                    paddingBlock="8px"
                                    error={error?.email}
                                />
                            </Grid>
                        </Grid>
                    </AppDialog>

                    <AppDialog
                        open={assignManagerOpen}
                        close={() => setAssignManagerOpen(false)}
                        title={`${selectedMember?.role === "Manager" ? "Discharge" : "Assign"} dealer manager`}
                        positiveTitle={selectedMember?.role === "Manager" ? "Discharge manager" : "Assign manager"}
                        positiveButtonStyle={{ color: "white", borderRadius: "20px", backgroundColor: "black", border: "1px solid black", width: width > 768 ? "auto" : "50%", }}
                        negativeButtonStyle={{ backgroundColor: "#F9F9F9", color: "#808588", border: "none", borderRadius: "20px", width: width > 768 ? "auto" : "50%" }}
                        negativeTitle={'Cancel'}
                        positivePress={() => handleAssignManager()}
                        negativePress={() => setAssignManagerOpen(false)}
                        width={'50%'}
                        isMobile={width <= 768 ? true : false}
                    >
                        <Grid container>
                            <Grid item xs={12}>
                                <div className="" style={{ fontSize: width > 768 ? undefined : 15 }}>You are about to {selectedMember?.role === "Manager" ? "discharge" : "assign"} <strong>{selectedMember?.name || "-"}</strong> as the <strong>Dealer Manager</strong> for this dealer.</div>
                            </Grid>

                            <Grid container style={{ marginTop: '20px', border: "none", backgroundColor: "#F4C06D33", padding: "15px", borderRadius: "8px", marginBottom: "20px", borderLeft: "1px solid #F4C06D" }}>
                                <Grid item xs={1}>
                                    <div style={{ border: "1px solid white", borderRadius: "100px", display: "inline-flex", padding: "4px", backgroundColor: 'white', marginTop: '5px' }}>
                                        <Icon icon="solar:danger-triangle-linear" />
                                    </div>
                                </Grid>
                                <Grid item xs={11} sx={{ paddingLeft: 0.5 }}>
                                    Each dealer team can have <strong>multiple</strong> managers at a time. Once {selectedMember?.role === "Manager" ? "discharged" : "assigned"}, <strong>{selectedMember?.role === "Manager" ? "this member will no longer have manager permissions" : "this member will gain manager permissions."}</strong>{selectedMember?.role === "Manager" ? ", but will remain as a member in the team." : ""}
                                </Grid>
                            </Grid>

                            <Grid item xs={12}>
                                <div className="" style={{ fontSize: width > 768 ? undefined : 15 }}>Are you sure you want to proceed?</div>
                            </Grid>
                        </Grid>
                    </AppDialog>

                    {/* Delete modal for team members*/}
                    <DeleteModal
                        open={removeMemberOpen}
                        title='Remove Member'
                        message={'Are you sure you want to remove this member from your team?'}
                        positiveTitle='Remove'
                        positiveButtonStyle={{
                            backgroundColor: '#D13536',
                            color: "white",
                            border: "none",
                            borderRadius: "20px",
                            width: width > 768 ? "auto" : "50%",
                        }}
                        negativeButtonStyle={{
                            width: width > 768 ? "auto" : "50%",
                            color: "#808588",
                            backgroundColor: "#F9F9F9",
                            border: "0px solid black",
                            borderRadius: "20px",
                        }}
                        close={() => setRemoveMemberOpen(false)}
                        width={"35%"}
                        height={"10%"}
                        submit={() => { handleRemoveMember() }}
                        isMobile={width <= 768 ? true : false}
                        mobileSizeModalMaxHeight={"43vh"}
                    />
                </div>;
            case 'profile_info':
                return !isEdit ? (
                    <div>
                        <Stack spacing={2} pb={3} style={{ display: "flex", justifyContent: "space-between", flexDirection: "row", alignItems: "center" }}>
                            <Stack display="flex" flexDirection="row" gap={2} alignItems="center">
                                <Avatar
                                    src={details?.profile_photo_path ? details.profile_photo_path : null}
                                    sx={{ width: 50, height: 50 }}
                                />
                                <div style={{ flexDirection: "column", display: "flex" }}>
                                    <Stack direction="row" alignItems="center" gap={1}>
                                        <span style={{ fontSize: "16px", fontWeight: 600, }}>{details?.name || "-"}</span>
                                        <Label.GeneralStatusLabel label={details?.status} list={Helpers.profileTeamMemberStatus} marginLeft={"0px"} />
                                    </Stack>
                                    <span className="text-muted font-size-14">{details?.email || "-"}</span>
                                </div>
                            </Stack>
                        </Stack>

                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <span className="text-muted font-size-12">Name</span>
                                <div className="font-size-14 pt-1">{details?.name || "-"}</div>
                            </Grid>

                            <Grid item xs={12}>
                                <span className="text-muted font-size-12">Email address</span>
                                <div className="font-size-14 pt-1">{details?.email || "-"}</div>
                            </Grid>

                            <Grid item xs={12}>
                                <span className="text-muted font-size-12">Phone number</span>
                                <div className="font-size-14 pt-1">{details?.phone || "-"}</div>
                            </Grid>

                            <Grid item xs={12} pt={2}>
                                <CustomButton
                                    title="Edit"
                                    press={() => {
                                        setIsEdit(true);
                                    }}
                                    textColor={"#808588"}
                                    backgroundColor={"#F9F9F9"}
                                    borderStyle={"#F9F9F9"}
                                    height={"36px"}
                                    width={"97px"}
                                />
                            </Grid>
                        </Grid>
                    </div>) : (

                    // if isEdit is true
                    <div>
                        <Stack spacing={2} pb={2} style={{ display: "flex", justifyContent: "space-between", flexDirection: "row", alignItems: "center" }}>
                            <Stack display="flex" flexDirection="row" gap={2} alignItems="center">
                                <Avatar
                                    src={values?.profile_photo_path}
                                    alt="profile"
                                    sx={{ width: 50, height: 50 }}
                                />
                                <Stack direction="row" gap={2}>
                                    <CustomButton
                                        title="Upload"
                                        press={() => {
                                            document.getElementById('profile-upload-input').click();
                                        }}
                                        backgroundColor="#1D1B1B"
                                        textColor="white"
                                        height={"36px"}
                                        width={width > 768 ? "auto" : "100px"}
                                    />
                                    <input
                                        id="profile-upload-input"
                                        type="file"
                                        accept="image/*"
                                        style={{ display: 'none' }}
                                        onChange={handleImageChange}
                                    />
                                    <CustomButton
                                        title="Remove"
                                        press={() => {
                                            setProfileImg("/images/users/default_user.png");
                                            setProfileImgFile(null);
                                        }}
                                        backgroundColor={"#F9F9F9"}
                                        textColor="#808588"
                                        height="36px"
                                        width={width > 768 ? "auto" : "100px"}
                                        borderStyle={width > 768 ? undefined : "none"}
                                    />
                                </Stack>
                            </Stack>
                        </Stack>

                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <CustomTextField
                                    title="Name"
                                    values={values?.name || ''}
                                    onChange={(e) => handleFormObjectChange('name', e)}
                                    placeholder="Enter name"
                                    paddingBlock="8px"
                                    error={error?.name}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <CustomTextField
                                    title="Email address"
                                    values={values?.email}
                                    onChange={(e) => handleFormObjectChange('email', e)}
                                    placeholder="Enter email address"
                                    paddingBlock="8px"
                                    error={error?.email}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <CustomTextField
                                    title="Phone Number"
                                    values={values?.phone}
                                    onChange={(e) => handleFormObjectChange('phone', e)}
                                    placeholder="Enter phone number"
                                    paddingBlock="8px"
                                    type="phone"
                                    InputProps={{
                                        startAdornment: (
                                            <div style={{
                                                paddingRight: 10,
                                                paddingLeft: 10,
                                                color: '#101010',
                                                borderRight: '1.5px solid #E6E6E6',
                                            }}>
                                                +65
                                            </div>
                                        ),
                                    }}
                                />
                            </Grid>

                            <Grid item xs={12} pt={2}>
                                <Stack direction="row" spacing={2} gap={1}>
                                    <CustomButton
                                        title="Save changes"
                                        press={() => {
                                            handlesubmit();
                                        }}
                                        backgroundColor="#1D1B1B"
                                        textColor="white"
                                        height="36px"
                                        width="150px"
                                    />
                                    <CustomButton
                                        title="Cancel"
                                        press={() => {
                                            setIsEdit(false);
                                            setFormValues({
                                                name: details?.name || "",
                                                email: details?.email || "",
                                                phone: details?.phone || "",
                                                profile_photo_path: details?.profile_photo_path,
                                                profile_photo_name: details?.profile_photo_name,
                                            });
                                        }}
                                        backgroundColor={"#F9F9F9"}
                                        textColor="#808588"
                                        height="36px"
                                        width="115px"
                                        borderStyle={width > 768 ? undefined : "none"}
                                    />
                                </Stack>
                            </Grid>
                        </Grid>

                    </div>

                );
            case 'password_security':
                return (
                    <div>
                        {/* <Stack spacing={2} pb={3}>
                            <span style={{ fontSize: "16px", fontWeight: 600 }}>Password & Security</span>
                        </Stack> */}
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <CustomTextField
                                    title="Current password"
                                    values={values?.current_password || ''}
                                    onChange={(e) => handleFormObjectChange('current_password', e)}
                                    placeholder="Enter current password"
                                    paddingBlock="8px"
                                    typePw={showPasswords.current ? "text" : "password"}
                                    InputProps={{
                                        endAdornment: (
                                            <IconButton
                                                onClick={() => setShowPasswords(prev => ({ ...prev, current: !prev.current }))}
                                                edge="end"
                                                style={{ padding: 0, marginRight: 2 }}
                                            >
                                                <Icon icon={showPasswords.current ? "solar:eye-linear" : "solar:eye-closed-linear"} width={20} height={20} color="#808588" />
                                            </IconButton>
                                        ),
                                    }}
                                    error={error?.current_password}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <CustomTextField
                                    title="New password"
                                    values={values?.new_password || ''}
                                    onChange={(e) => handleFormObjectChange('new_password', e)}
                                    placeholder="Enter new password"
                                    paddingBlock="8px"
                                    typePw={showPasswords.new ? "text" : "password"}
                                    InputProps={{
                                        endAdornment: (
                                            <IconButton
                                                onClick={() => setShowPasswords(prev => ({ ...prev, new: !prev.new }))}
                                                edge="end"
                                                style={{ padding: 0, marginRight: 2 }}
                                            >
                                                <Icon icon={showPasswords.new ? "solar:eye-linear" : "solar:eye-closed-linear"} width={20} height={20} color="#808588" />
                                            </IconButton>
                                        ),
                                    }}
                                    error={error?.new_password}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <CustomTextField
                                    title="Confirm new password"
                                    values={values?.new_password_confirmation || ''}
                                    onChange={(e) => handleFormObjectChange('new_password_confirmation', e)}
                                    placeholder="Re-enter new password"
                                    paddingBlock="8px"
                                    typePw={showPasswords.confirm ? "text" : "password"}
                                    InputProps={{
                                        endAdornment: (
                                            <IconButton
                                                onClick={() => setShowPasswords(prev => ({ ...prev, confirm: !prev.confirm }))}
                                                edge="end"
                                                style={{ padding: 0, marginRight: 2 }}
                                            >
                                                <Icon icon={showPasswords.confirm ? "solar:eye-linear" : "solar:eye-closed-linear"} width={20} height={20} color="#808588" />
                                            </IconButton>
                                        ),
                                    }}
                                />
                            </Grid>

                            <Grid item xs={12} pt={2}>
                                <CustomButton
                                    title="Save changes"
                                    press={() => {
                                        handlePasswordSubmit();
                                    }}
                                    backgroundColor="#1D1B1B"
                                    textColor="white"
                                    height="36px"
                                    width={width > 768 ? "150px" : "100%"}
                                />
                            </Grid>
                        </Grid>
                    </div>
                );
            default:
                return "";
        }
    }

    return (
        <React.Fragment>
            <div className="page-content" style={{ marginTop: width <= 768 && leftSideBarType === 'condensed' ? 72 : 0, backgroundColor: width > 768 ? "#f5f6fa" : "white" }}>
                <Container fluid>
                    <LoadingDialog open={loading || (selected === "branch" ? branchDetails?.code !== "success" : selected === 'store_details' && !details?.user_name)} />
                    <Notification notification={notification} setNotification={setNotification} errors={error} />

                    {width > 768 ? (
                        <Card style={{ padding: "30px", borderRadius: 5, minHeight: "100vh" }}>
                            <Grid container spacing={2}>
                                <Grid item xs={4}>
                                    <Stack className="sticky-side-tabs" sx={{ paddingLeft: 4, paddingTop: 2 }} spacing={2}>
                                        <span style={{ fontSize: "20px", fontWeight: 600, paddingBottom: "20px", cursor: "pointer" }}>Profile </span>
                                        {currentAccount?.dealer_id &&
                                            <>
                                                <div style={{ color: selected === "store_details" ? "black" : "#808588", cursor: "pointer" }} onClick={(e) => selected !== "store_details" && handleTabChange("store_details")}> <Icon icon="solar:shop-bold-duotone" className="me-2" /> Store Details</div>
                                                <div style={{ color: selected === "branch" ? "black" : "#808588", cursor: "pointer" }} onClick={(e) => selected !== "branch" && handleTabChange("branch")}> <Icon icon="solar:shop-2-bold" className="me-2" />Branch</div>
                                                <div style={{ color: selected === "salesman" ? "black" : "#808588", cursor: "pointer" }} onClick={(e) => selected !== "salesman" && handleTabChange("salesman")}><Icon icon="solar:case-minimalistic-bold-duotone" className="me-2" /> Salesman</div>
                                                <div style={{ color: selected === "team_members" ? "black" : "#808588", cursor: "pointer" }} onClick={(e) => selected !== "team_members" && handleTabChange("team_members")}><Icon icon="solar:users-group-two-rounded-bold-duotone" className="me-2" /> Team Members</div>
                                            </>}
                                        <div style={{ color: selected === "profile_info" ? "black" : "#808588", cursor: "pointer" }} onClick={(e) => { selected !== "profile_info" && handleTabChange("profile_info"); setIsEdit(false) }}><Icon icon="solar:user-bold-duotone" className="me-2" /> Profile Info</div>
                                        {/* <div style={{ color: selected === "password_security" ? "black" : "#808588", cursor: "pointer" }} onClick={(e) => handleTabChange("password_security")}><Icon icon="solar:lock-keyhole-minimalistic-bold-duotone" className="me-2" /> Password & Security</div> */}
                                    </Stack>
                                </Grid>
                                <Grid item xs={8} sx={{ marginTop: 2 }}>
                                    {renderContent()}
                                </Grid>
                            </Grid>
                        </Card>
                    ) : (
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <div style={{ fontSize: "20px", fontWeight: 600, marginBottom: "16px" }}>Profile</div>
                                <div style={{
                                    position: 'sticky',
                                    top: 0,
                                    backgroundColor: 'white',
                                    zIndex: 100,
                                    marginBottom: '16px',
                                }}>
                                    <Stack direction="row" spacing={2} style={{ overflowX: 'auto', paddingBottom: '8px', }}>
                                        <div
                                            onClick={() => handleTabChange("store_details")}
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                gap: '8px',
                                                minWidth: 'fit-content',
                                                cursor: 'pointer',
                                                color: selected === "store_details" ? "black" : "#808588",
                                                paddingRight: '16px'
                                            }}
                                        >
                                            <Icon icon="solar:shop-bold-duotone" width={16} height={16} />
                                            <span style={{ fontSize: '14px', whiteSpace: 'nowrap' }}>Store Details</span>
                                        </div>
                                        <div
                                            onClick={() => handleTabChange("salesman")}
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                gap: '8px',
                                                minWidth: 'fit-content',
                                                cursor: 'pointer',
                                                color: selected === "salesman" ? "black" : "#808588",
                                                paddingRight: '16px'
                                            }}
                                        >
                                            <Icon icon="solar:case-minimalistic-bold-duotone" width={16} height={16} />
                                            <span style={{ fontSize: '14px', whiteSpace: 'nowrap' }}>Salesman</span>
                                        </div>
                                        <div
                                            onClick={() => handleTabChange("team_members")}
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                gap: '8px',
                                                minWidth: 'fit-content',
                                                cursor: 'pointer',
                                                color: selected === "team_members" ? "black" : "#808588",
                                                paddingRight: '16px'
                                            }}
                                        >
                                            <Icon icon="solar:users-group-two-rounded-bold-duotone" width={16} height={16} />
                                            <span style={{ fontSize: '14px', whiteSpace: 'nowrap' }}>Team Members</span>
                                        </div>
                                        <div
                                            onClick={() => handleTabChange("profile_info")}
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                gap: '8px',
                                                minWidth: 'fit-content',
                                                cursor: 'pointer',
                                                color: selected === "profile_info" ? "black" : "#808588",
                                                paddingRight: '16px'
                                            }}
                                        >
                                            <Icon icon="solar:user-bold-duotone" width={16} height={16} />
                                            <span style={{ fontSize: '14px', whiteSpace: 'nowrap' }}>Profile Info</span>
                                        </div>
                                        <div
                                            onClick={() => handleTabChange("password_security")}
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                gap: '8px',
                                                minWidth: 'fit-content',
                                                cursor: 'pointer',
                                                color: selected === "password_security" ? "black" : "#808588",
                                                paddingRight: '16px'
                                            }}
                                        >
                                            <Icon icon="solar:lock-keyhole-minimalistic-bold-duotone" width={16} height={16} />
                                            <span style={{ fontSize: '14px', whiteSpace: 'nowrap' }}>Password & Security</span>
                                        </div>
                                    </Stack>
                                </div>
                            </Grid>
                            <Grid item xs={12}>
                                {renderContent()}
                            </Grid>
                        </Grid>
                    )}
                </Container>
                <AppAttachmentDialog
                    open={attachmentOpen}
                    close={() => setAttachmentOpen(false)}
                    file={selectedFile}
                    fileName={'banner_image'}
                    filetype={'png'}
                />
            </div>
        </React.Fragment >
    );
};

function mapStateToProps({ Login, Profile, General, Layout, Branch }) {
    return {
        details: Profile.profile,
        detailsCode: Profile,
        editUserProfile: Profile.editProfile,
        createSalesmanResponse: Profile?.createSalesman,
        deleteSalesmanResponse: Profile?.deleteSalesman,
        inviteTeamMemberResponse: Profile?.inviteTeamMember,
        removeTeamMemberResponse: Profile?.removeTeamMember,
        setSalesmanAsDefaultResponse: Profile?.setSalesmanAsDefault,
        reinviteTeamMemberResponse: Profile?.reinviteTeamMember,
        removeInvitationResponse: Profile?.removeTeamMemberInvitation,
        editUserPwd: Profile.editUserPwd,
        error: Profile.editProfile?.errors || Profile.createSalesman?.errors || Profile.inviteTeamMember?.errors,
        profileImgBase64: General.attachment,
        stateList: General?.states,
        regionList: General?.regionRegister,
        countryList: General?.countries,
        userPermission: Login.permissionArry,
        leftSideBarType: Layout.leftSideBarType,
        width: Layout.currentWidth,
        loginStateId: Login?.verifyAdmin?.user?.data?.profile?.state_id,
        userID: Login?.verifyAdmin?.user?.data?.profile?.id,
        dealer_marketplace_url: Login?.verifyAdmin?.user?.data?.profile?.dealer_marketplace_url,
        branchDetails: Branch?.branchListing,
        branchError: Branch?.error,
        updateBranchArry: Branch?.branchEdit,
        addBranchArry: Branch?.branchAdd,
        delBranchArry: Branch?.branchDelete,
        dealer_branches: General?.dealer_branches,

        verifyAdmin: Login.verifyAdmin,
        currentUser: Login.verifyAdmin?.user?.data?.profile,

    };
}

export default connect(mapStateToProps)(UserProfile);
